import { WeatherDispatch, WeatherSelect } from "@/store/type";
import { WEATHER_STORE } from "@/store/store";
import { useDispatch, useSelect } from "@wordpress/data";
import { getCurrentDateWithDay } from "@/helpers/format-date";
import { getPrevisionButtonStatus } from "@/blocks/weather-forecast-prevision-city/helpers/prevision-button-helper";
import { getForecastByDate } from "@/helpers/format-forecast-data-by-date";

import PrevisionTableSmall from "@/components/prevision-table-small/PrevisionTableSmall";
import PrevisionButton from "@/components/prevision-button/PrevisionButton";

import "./style.scss";

export const App = () => {
	const currentDate = new Date().getDate();

	const { forecastData, isLoading, error, selectedDate } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
			const store = select(WEATHER_STORE);

			return {
				...store.getWorldForecastPrevisionState(),
				selectedDate: store.getWorldForecastPrevisionDateState(),
			};
		},
	);
	const { setWorldCitiesForecastDate } = useDispatch(
		WEATHER_STORE,
	) as WeatherDispatch;

	if (forecastData.length === 0 && (!isLoading || !error)) return null;

	const dataToMap = getForecastByDate({
		selectedDate: new Date(selectedDate),
		forecastData,
	});

	const { day, date } = getCurrentDateWithDay(new Date(selectedDate));

	const handleClick = (action: "next" | "prev") => {
		let storeDate = new Date(selectedDate);

		if (action === "prev" && currentDate === storeDate.getDate()) {
			return;
		}

		if (action === "prev") {
			storeDate = new Date(
				new Date(storeDate).setDate(storeDate.getDate() - 1),
			);
		} else {
			storeDate = new Date(
				new Date(storeDate).setDate(storeDate.getDate() + 1),
			);
		}

		setWorldCitiesForecastDate(storeDate);
	};

	return (
		<div className="world-forecast-prevision">
			<PrevisionButton
				isPrev={true}
				isActive={getPrevisionButtonStatus({
					direction: "prev",
					dateSelected: selectedDate,
				})}
				handleClick={() => handleClick("prev")}
			/>

			<div className="content">
				<PrevisionTableSmall showDate={`${day} ${date}`} data={dataToMap} />
			</div>

			<PrevisionButton
				isPrev={false}
				isActive={getPrevisionButtonStatus({
					direction: "next",
					dateSelected: selectedDate,
					addDate: 2,
				})}
				handleClick={() => handleClick("next")}
			/>
		</div>
	);
};

export default App;
